import { defineSlotRecipe } from "@pandacss/dev";

export const aromaFiguresCard = defineSlotRecipe({
  className: "aroma-figures-card",
  jsx: ["FiguresCard"],
  slots: ["root", "content", "text", "value", "action", "rightPart"],
  base: {
    root: {
      border: "1px solid",
      borderRadius: "l",
      borderColor: "border.neutral.subtle",
      py: "padding.3",
      px: "padding.4",
      alignItems: "center",
      gap: "gap.4",
      display: "flex",
      flexDirection: "row",
    },
    content: {
      width: "100%",
      gap: "gap.2",
      flex: "1",
    },
    text: {
      justifyContent: "center",
      alignItems: "initial",
      gap: "gap.0",
      flex: "1",
      flexDirection: "column",
    },
    rightPart: {
      alignItems: "center",
      gap: "gap.2",
    },
    action: {
      alignItems: "center",
    },
  },
  variants: {
    stacked: {
      true: {
        root: {
          alignItems: "baseline",
          gap: "gap.1",
          flexDirection: "column",
        },
        value: {
          alignItems: "center",
          paddingLeft: "padding.10",
          width: "100%",
        },
      },
    },
    error: {
      true: {
        value: {
          color: "content.functional.error",
        },
      },
    },
  },
});
